export const environment = {
  production:false,
  baseUrl:'https://apigw-qa.fastshop.com.br/financial/v0/financial-manager',
  closureUrl:'https://apigw-qa.fastshop.com.br/financial/v0/financial-closure',
  urlLogin:'https://parceirofast-qa.fastshop.com.br/',
  altApige: 'https://apigw-qa.fastshop.com.br/financial/v0/financial-closure',
  devLocal:true
};
//https://apiqa.fastshop.com.br/v1/financial-closure
